// ============================================
// Home Module - Search (ES6)
// 검색 모달 관리
// ============================================

import { renderHomeCard } from './content.js';
import { getAllPublishedContent } from './detail/state.js';

// ============================================
// 검색 모달 열기/닫기
// ============================================

export function openSearchModal() {
  document.getElementById('searchModal').style.display = 'flex';
  document.getElementById('searchInput').focus();
  window.ModalManager?.push('searchModal');
}

export function closeSearchModal() {
  document.getElementById('searchModal').style.display = 'none';
  document.getElementById('searchInput').value = '';
  document.getElementById('searchResults').innerHTML = '<div class="search-placeholder">검색어를 입력하세요</div>';
  window.ModalManager?.remove('searchModal');
}

// ============================================
// 검색 실행
// ============================================

export function handleSearch() {
  const query = document.getElementById('searchInput').value.trim().toLowerCase();
  const resultsEl = document.getElementById('searchResults');

  if (!query) {
    resultsEl.innerHTML = '<div class="search-placeholder">검색어를 입력하세요</div>';
    return;
  }

  const allContent = getAllPublishedContent();
  const results = allContent.filter(c => {
    const title = (c.title || '').toLowerCase();
    const desc = (c.description || '').toLowerCase();
    const shortDesc = (c.shortDesc || '').toLowerCase();
    const tags = (c.tags || []).join(' ').toLowerCase();
    return title.includes(query) || desc.includes(query) || shortDesc.includes(query) || tags.includes(query);
  });

  if (results.length === 0) {
    resultsEl.innerHTML = '<div class="search-placeholder">검색 결과가 없습니다</div>';
    return;
  }

  resultsEl.innerHTML = `<div class="search-results-grid">${results.map(c => renderHomeCard(c)).join('')}</div>`;
}

// window 노출 제거됨 - events.js에서 이벤트 리스너로 처리
